import { z } from 'zod';

export const toggleMfaGetResponseSchema = z.object({
  data: z.object({ mfa_enabled: z.boolean().optional() }),
  response: z.object({ date: z.string(), messages: z.array(z.string()), status: z.number(), type: z.string() }),
});
